import LogoHeader from '../../assets/img/pic-menu-logo-large@2x.png'

const Logo = ({ collapsed }: { collapsed: boolean }) => {
  return collapsed ? (
    <div style={{ height: '64px' }} />
  ) : (
    <img src={LogoHeader} style={{ height: '40px', margin: '12px' }} alt="logo" />
  )
}

export default Logo
